/* @flow */
// eslint-disable-next-line
import { FileSystem } from '@forlagshuset/simple-fs'
import type { Book, TableOfContent } from '../flow/book'
import { readFileAsText } from '../utils/utils'

const IDBfileSystem = new FileSystem({name: 'dur'})

export class OfflineHandler {
  fs: Object

  constructor (fs: Object, rootDir: string = '/books') {
    this.fs = fs
    this.rootDir = rootDir
  }

  async createRootDir(): void {
    await this.fs.mkdir(this.rootDir)
  }

  async getBook (bookId: string): Promise<Book> {
    const bookMetadataFile = `${this.rootDir}/${bookId}/book.json`
    const data = JSON.parse(await this.getFileAsText(bookMetadataFile))

    return new Promise((resolve, reject) => {
      const metaDataKeys = Object.keys(data).filter(x => x.startsWith('-') === true)
      let book = {
        _id: data.id,
        title: data.title,
        author: data.author,
        publisher: data.publisher,
        metadata: {
          'orientation': data.orientation,
          'zoomable': data.zoomable
        },
        status: 'LOCAL',
        content: []
      }

      data.contents.forEach((name, i) => {
        book.content.push({name: name, label: name, position: i + 1, type: 'page'})
      })

      metaDataKeys.forEach((name) => {
        book.metadata[name] = data[name]
      })

      resolve(book)
    })
  }

  async getTableOfContent(bookId: string): TableOfContent {
    const tocFile = `${this.rootDir}/${bookId}/toc.json`

    return JSON.parse(await this.getFileAsText(tocFile))
  }

  async outputFile(path: string, blob: Blob) {
    return await this.fs.outputFile(path, blob)
  }

  async bulkOutputFiles(objs: [{path: string, blob: Blob}]) {
    return await this.fs.bulkOutputFiles(objs)
  }

  async removeBook(bookId: string) {
    await this.fs.rmdirRecursive('/books/' + bookId)
  }

  async getFileAsText (file: string): Promise<string> {
    const blob = await this.fs.readFile(file)

    return readFileAsText(blob)
  }

  async getSavedBooks(): Promise<Array> {
    if (!await this.fs.exists(this.rootDir)) {
      await this.createRootDir()
    }

    return this.fs.ls(this.rootDir)
  }
}

export default new OfflineHandler(IDBfileSystem)
